import { render, staticRenderFns } from "./CustomerQaGroup.vue?vue&type=template&id=19616b9a&scoped=true&"
import script from "./CustomerQaGroup.vue?vue&type=script&lang=js&"
export * from "./CustomerQaGroup.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQaGroup.vue?vue&type=style&index=0&id=19616b9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19616b9a",
  null
  
)

export default component.exports